import React from "react";
import styles from "./content.module.css";
import { withTheme } from "@material-ui/core";
import { isAndroid } from "react-device-detect";

class ContentCard extends React.Component {
  render() {
    const { theme, title } = this.props;
    return (
      <>
        <div className={styles.outerContainer}>
          {title ? (
            <div
              className={styles.header}
              style={{
                background: `linear-gradient(0.9turn, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 99%)`
              }}
            >
              {title}
            </div>
          ) : null}
          <div className={styles.container}>
            <>{this.props.children}</>
          </div>
        </div>
        {isAndroid ? <div style={{ height: "300px", width: "100vw" }} /> : null}
      </>
    );
  }
}

export default withTheme()(ContentCard);
